import * as d3 from 'd3'
export default {
  methods: {

    draw_Stage(selection, stg) {

      let stgGroup = selection
      .append('g')
      .attr('transform', `translate(0, 0)`).attr('cursor', 'pointer').attr('opacity', 1)
      .on('mouseover', function() {
        d3.select(this).transition().duration(75).attr('opacity', .5)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(250).attr('opacity', 1)
      })
      .on('click', () => {

        let count = this.db_Table.filter(f=> f.IDX == stg.IDX && f.STG_NO == stg.STG_NO && f.RELATION == 'Exec').length

        if(count == 0) {
          let message = [
            {text: 'Execution is not possible because',},
            {text: 'no stored procedure is registered.',},
          ]
          this.gmx_openPopup(this.diagramCanvas, {type: 'Alert', msg: message})
        } else {
          let message = [
            {text: 'Once this store procedure is executed, ',},
            {text: 'it cannot be undone.',},
            {text: 'Do you want to proceed??',},
          ]
          this.exec_Popup(message, 'STAGE', stg) // -----> set_Exection.js
        }
      })

      stgGroup
      .append('rect')
      .attr('rx', 5).attr('ry', 5).attr('width', stg.width).attr('height', 40)
      .attr('fill', `url(#${this.localId}_SkyBlue_H2)`)
      .attr('stroke', '#E0E0DF').attr('stroke-width', 2).attr('opacity', .5)

      stgGroup
      .append('text')
      .attr('x', stg.width/2).attr('y', 25)
      .attr('fill', '#000').attr('font-size', 14).attr('text-anchor', 'middle').attr('font-weight', 500)
      .text(`${stg.STAGE}`)


      // Modal Forms
      selection
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/icon/Input.svg`)
      .attr('x', stg.width-84).attr('y', -27).attr('width', 22).attr('opacity', .4)
      .call(this.gmx_openWindow, {exeFunc: this.table_Viewer, mode: 'Input', width: 900, height: 720, stg: stg,}, 'reverse') // -----> this.table_Viewer()

      selection
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/icon/Exec.svg`)
      .attr('x', stg.width-54).attr('y', -27).attr('width', 22).attr('opacity', .4)
      .call(this.gmx_openWindow, {exeFunc: this.table_Viewer, mode: 'Exec', width: 900, height: 720, stg: stg,}, 'reverse') // -----> this.table_Viewer()

      selection
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/icon/Output.svg`)
      .attr('x', stg.width-24).attr('y', -27).attr('width', 22).attr('opacity', .4)
      .call(this.gmx_openWindow, {exeFunc: this.table_Viewer, mode: 'Output', width: 900, height: 720, stg: stg,}, 'reverse') // -----> this.table_Viewer()
    },


    child_InputList(stg, data) {
      
      data = data.filter(f=> f.RELATION == 'Input')
      // console.log(data)
      let y_ = data.length > 0 ? -(data.length * 25)+10 : 0

      let inOut = this.diagramCanvas
      .append('g')
      .attr('id', `INPUT_LIST_${stg.STG_NO}`)
      .attr('transform', `translate(${stg.sx}, ${stg.y})`)

      if(data.length > 0) {
        this.gmx_Line(inOut, -10, -10, y_, (20/4), '#bcbcbc', .5, 1)
        this.gmx_Line(inOut, -10, 0, (20/4), (20/4), '#bcbcbc', .5, 1)
      }

      data.forEach((d,i)=> {
        this.gmx_Line(inOut, -10, -20, y_+1, y_+1, '#bcbcbc', .5, 1)

        let item = inOut
        .append('g')
        .attr('transform', `translate(-20, 0)`)
        .call(this.call_TableOver, d)
        
        item
        .append('circle')
        .attr('cx', 0).attr('cy', y_+1).attr('r', 2.5).attr('fill', '#bcbcbc')
        
        item
        .append('image')
        .attr('xlink:href', this.HOST + `/Database/icon/DB_${d.TYPE}.svg`).attr('x', -22).attr('y', y_-8).attr('height', 17)

        item
        .append('text')
        .attr('id', `TABLE_${d.SN}`)
        .attr('x', -25).attr('y', y_  + 5)
        .attr('fill', '#333').attr('font-size', 11).attr('text-anchor', 'end')
        .text(d.TYPE == 'Excel' ? `${d.NAME}` : `${d.SCHEMA}.${d.NAME}`)

        item
        .append('rect')
        .attr('x', -(this.getNode(`#TABLE_${d.SN}`) + 40)).attr('y', y_-10)
        .attr('width', this.getNode(`#TABLE_${d.SN}`) + 45).attr('height', 20).attr('opacity', 0)

        y_ += 25
      })
    },


    child_ExecList(stg, data) {
       
      data = data.filter(f=> f.RELATION == 'Exec')

      let exec = this.diagramCanvas
      .append('g')
      .attr('id', `EXECUTION_LIST_${stg.STG_NO}`)
      .attr('transform', `translate(${stg.sx}, ${stg.y + 33})`)
      
      let y_ = 20
      data.forEach(d=> {
        let item = exec
        .append('g')
        .attr('transform', `translate(0, 0)`)

        item
        .append('image')
        .attr('xlink:href', this.HOST + `/Database/icon/DB_Procedure.svg`).attr('x', 0).attr('y', y_-6).attr('height', 13)

        item
        .append('text')
        .attr('id', `TABLE_${d.SN}`)
        .attr('x', 17).attr('y', y_ + 5).attr('fill', '#333').attr('font-size', 11)
        .text(`${d.SCHEMA}.${d.NAME}`)

        item
        .append('rect')
        .attr('x', 0).attr('y', y_-10)
        .attr('width', this.getNode(`#TABLE_${d.SN}`) + 30).attr('height', 20).attr('opacity', 0)
        
        y_ += 25
      })

    },


    child_OutputList(stg, data) {

      data = data.filter(f=> f.RELATION == 'Output')

      let inOut = this.diagramCanvas
      .append('g')
      .attr('id', `OUTPUT_LIST_${stg.STG_NO}`)
      .attr('transform', `translate(${stg.ex}, ${stg.y-10})`)

      if(data.length > 0) {
        this.gmx_Line(inOut, 0, 10, (40 - (40/4)), (40 - (40/4)), '#bcbcbc', .5, 1)
      }

      let y_ = 40 + 20
      data.forEach(d=> {
        
        this.gmx_Line(inOut, 10, 20, y_+1, y_+1, '#bcbcbc', .5, 1)

        let item = inOut
        .append('g')
        .attr('transform', `translate(10, 0)`)
        .attr('opacity', 1)
        .call(this.call_TableOver, d)

        item
        .append('circle')
        .attr('cx', 10).attr('cy', y_+1).attr('r', 3).attr('fill', '#bcbcbc')

        item
        .append('image')
        .attr('xlink:href', this.HOST + `/Database/icon/DB_${d.TYPE}.svg`).attr('x', 15).attr('y', y_-8).attr('height', 17)

        item
        .append('text')
        .attr('id', `TABLE_${d.SN}`)
        .attr('x', 35).attr('y', y_ + 5)
        .attr('fill', stg.STG_NO ==this.stageList.length-1 ? '#000' : '#333')
        .attr('font-size', stg.STG_NO ==this.stageList.length-1 ? 12 : 11)
        .text(`${d.SCHEMA}.${d.NAME}`)

        item
        .append('rect')
        .attr('x', 0).attr('y', y_-10)
        .attr('width', this.getNode(`#TABLE_${d.SN}`) + 45).attr('height', 20).attr('opacity', 0)

        y_ += 25
      })
      this.gmx_Line(inOut, 10, 10, 40 - (40/4), y_-24+1, '#bcbcbc', .5, 1)
    },

  }
}